import React from 'react';

import { StyledBoxInside, StyledTitleWidget } from './RentalInquiry/style';
import { StyledBoxEmployee, StyledLink } from './style';

import { OndaceroWhite } from '../../../../assets/images/index';

const OndaCeroServices = () => (
  <StyledBoxInside>
    <StyledTitleWidget
      title="Servicios Onda Cero"
      type="ondacero"
      icon={OndaceroWhite}
      small
    />
    <StyledBoxEmployee title="Seleccionar un servicio">
      <ul>
        <li>
          <StyledLink to="/consulta-emisoras">Consulta de emisoras</StyledLink>
        </li>
        <li>
          <StyledLink to="/consulta-alquileres">
            Consulta de alquileres
          </StyledLink>
        </li>
      </ul>
    </StyledBoxEmployee>
  </StyledBoxInside>
);

export default OndaCeroServices;
